import Filters from './Filters.component';

export default Filters;
